// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/profile/v1/update.proto (package gdx.gateway.web.profile.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ProfileBodyType, ProfileChildren, ProfileDrinking, ProfileEducation, ProfileEthnicity, ProfileEyeColor, ProfileGender, ProfileHairColor, ProfileHeight, ProfileLocation, ProfileLookingFor, ProfileMaritalStatus, ProfileReligion, ProfileSexualOrientation, ProfileSmoking, ProfileSphereOfWork, ProfileSport } from "./profile_pb.js";

/**
 * Wraps field value to be able to use typed repeated fields.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileField
 */
export class ProfileField extends Message<ProfileField> {
  /**
   * @generated from oneof gdx.gateway.web.profile.v1.ProfileField.field
   */
  field: {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileGender gender = 1;
     */
    value: ProfileGender;
    case: "gender";
  } | {
    /**
     * @generated from field: string about = 2;
     */
    value: string;
    case: "about";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileSphereOfWork sphere_of_work = 3;
     */
    value: ProfileSphereOfWork;
    case: "sphereOfWork";
  } | {
    /**
     * @generated from field: string position = 4;
     */
    value: string;
    case: "position";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileInterestRepeated interests = 5;
     */
    value: ProfileInterestRepeated;
    case: "interests";
  } | {
    /**
     * @generated from field: string birth_place = 6;
     */
    value: string;
    case: "birthPlace";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileEducation education = 8;
     */
    value: ProfileEducation;
    case: "education";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileReligion religion = 9;
     */
    value: ProfileReligion;
    case: "religion";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileSexualOrientation sexual_orientation = 10;
     */
    value: ProfileSexualOrientation;
    case: "sexualOrientation";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileMaritalStatus marital_status = 11;
     */
    value: ProfileMaritalStatus;
    case: "maritalStatus";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileEthnicity ethnicity = 12;
     */
    value: ProfileEthnicity;
    case: "ethnicity";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileHeight height = 13;
     */
    value: ProfileHeight;
    case: "height";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileBodyType body_type = 15;
     */
    value: ProfileBodyType;
    case: "bodyType";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileHairColor hair_color = 16;
     */
    value: ProfileHairColor;
    case: "hairColor";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileChildren children = 17;
     */
    value: ProfileChildren;
    case: "children";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileDrinking drinking = 19;
     */
    value: ProfileDrinking;
    case: "drinking";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileSmoking smoking = 20;
     */
    value: ProfileSmoking;
    case: "smoking";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileLocation location = 21;
     */
    value: ProfileLocation;
    case: "location";
  } | {
    /**
     * @generated from field: bool is_location_update_allowed = 22;
     */
    value: boolean;
    case: "isLocationUpdateAllowed";
  } | {
    /**
     * @generated from field: bool is_location_detection_allowed = 23;
     */
    value: boolean;
    case: "isLocationDetectionAllowed";
  } | {
    /**
     * @generated from field: string name = 25;
     */
    value: string;
    case: "name";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileGender match_gender = 26;
     */
    value: ProfileGender;
    case: "matchGender";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileLookingForRepeated looking_for = 27;
     */
    value: ProfileLookingForRepeated;
    case: "lookingFor";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileSport sport = 28;
     */
    value: ProfileSport;
    case: "sport";
  } | {
    /**
     * Match profile section ( https://prnt.sc/swiji9 ).
     *
     * @generated from field: gdx.gateway.web.profile.v1.ProfileLookingForRepeated match_looking_for = 29;
     */
    value: ProfileLookingForRepeated;
    case: "matchLookingFor";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileReligionRepeated match_religion = 30;
     */
    value: ProfileReligionRepeated;
    case: "matchReligion";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileMaritalStatusRepeated match_marital_status = 31;
     */
    value: ProfileMaritalStatusRepeated;
    case: "matchMaritalStatus";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileEthnicityRepeated match_ethnicity = 32;
     */
    value: ProfileEthnicityRepeated;
    case: "matchEthnicity";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileSphereOfWorkRepeated match_sphere_of_work = 33;
     */
    value: ProfileSphereOfWorkRepeated;
    case: "matchSphereOfWork";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileSexualOrientationRepeated match_sexual_orientation = 34;
     */
    value: ProfileSexualOrientationRepeated;
    case: "matchSexualOrientation";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileHeight match_height_from = 35;
     */
    value: ProfileHeight;
    case: "matchHeightFrom";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileHeight match_height_to = 36;
     */
    value: ProfileHeight;
    case: "matchHeightTo";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileBodyTypeRepeated match_body_type = 39;
     */
    value: ProfileBodyTypeRepeated;
    case: "matchBodyType";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileHairColorRepeated match_hair_color = 40;
     */
    value: ProfileHairColorRepeated;
    case: "matchHairColor";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileChildren match_children = 41;
     */
    value: ProfileChildren;
    case: "matchChildren";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileDrinkingRepeated match_drinking = 42;
     */
    value: ProfileDrinkingRepeated;
    case: "matchDrinking";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileSmokingRepeated match_smoking = 43;
     */
    value: ProfileSmokingRepeated;
    case: "matchSmoking";
  } | {
    /**
     * @generated from field: string educational_institution = 44;
     */
    value: string;
    case: "educationalInstitution";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileEyeColor eye_color = 45;
     */
    value: ProfileEyeColor;
    case: "eyeColor";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileEyeColorRepeated match_eye_color = 46;
     */
    value: ProfileEyeColorRepeated;
    case: "matchEyeColor";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileSportRepeated match_sports = 47;
     */
    value: ProfileSportRepeated;
    case: "matchSports";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileInterestRepeated match_interests = 48;
     */
    value: ProfileInterestRepeated;
    case: "matchInterests";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileEducationRepeated match_education = 49;
     */
    value: ProfileEducationRepeated;
    case: "matchEducation";
  } | {
    /**
     * @generated from field: uint32 match_age_from = 50;
     */
    value: number;
    case: "matchAgeFrom";
  } | {
    /**
     * @generated from field: uint32 match_age_to = 51;
     */
    value: number;
    case: "matchAgeTo";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.ProfileLocation match_location = 52;
     */
    value: ProfileLocation;
    case: "matchLocation";
  } | {
    /**
     * @generated from field: string currency = 53;
     */
    value: string;
    case: "currency";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ProfileField>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileField";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender), oneof: "field" },
    { no: 2, name: "about", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 3, name: "sphere_of_work", kind: "enum", T: proto3.getEnumType(ProfileSphereOfWork), oneof: "field" },
    { no: 4, name: "position", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 5, name: "interests", kind: "message", T: ProfileInterestRepeated, oneof: "field" },
    { no: 6, name: "birth_place", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 8, name: "education", kind: "enum", T: proto3.getEnumType(ProfileEducation), oneof: "field" },
    { no: 9, name: "religion", kind: "enum", T: proto3.getEnumType(ProfileReligion), oneof: "field" },
    { no: 10, name: "sexual_orientation", kind: "enum", T: proto3.getEnumType(ProfileSexualOrientation), oneof: "field" },
    { no: 11, name: "marital_status", kind: "enum", T: proto3.getEnumType(ProfileMaritalStatus), oneof: "field" },
    { no: 12, name: "ethnicity", kind: "enum", T: proto3.getEnumType(ProfileEthnicity), oneof: "field" },
    { no: 13, name: "height", kind: "message", T: ProfileHeight, oneof: "field" },
    { no: 15, name: "body_type", kind: "enum", T: proto3.getEnumType(ProfileBodyType), oneof: "field" },
    { no: 16, name: "hair_color", kind: "enum", T: proto3.getEnumType(ProfileHairColor), oneof: "field" },
    { no: 17, name: "children", kind: "enum", T: proto3.getEnumType(ProfileChildren), oneof: "field" },
    { no: 19, name: "drinking", kind: "enum", T: proto3.getEnumType(ProfileDrinking), oneof: "field" },
    { no: 20, name: "smoking", kind: "enum", T: proto3.getEnumType(ProfileSmoking), oneof: "field" },
    { no: 21, name: "location", kind: "message", T: ProfileLocation, oneof: "field" },
    { no: 22, name: "is_location_update_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "field" },
    { no: 23, name: "is_location_detection_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "field" },
    { no: 25, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 26, name: "match_gender", kind: "enum", T: proto3.getEnumType(ProfileGender), oneof: "field" },
    { no: 27, name: "looking_for", kind: "message", T: ProfileLookingForRepeated, oneof: "field" },
    { no: 28, name: "sport", kind: "enum", T: proto3.getEnumType(ProfileSport), oneof: "field" },
    { no: 29, name: "match_looking_for", kind: "message", T: ProfileLookingForRepeated, oneof: "field" },
    { no: 30, name: "match_religion", kind: "message", T: ProfileReligionRepeated, oneof: "field" },
    { no: 31, name: "match_marital_status", kind: "message", T: ProfileMaritalStatusRepeated, oneof: "field" },
    { no: 32, name: "match_ethnicity", kind: "message", T: ProfileEthnicityRepeated, oneof: "field" },
    { no: 33, name: "match_sphere_of_work", kind: "message", T: ProfileSphereOfWorkRepeated, oneof: "field" },
    { no: 34, name: "match_sexual_orientation", kind: "message", T: ProfileSexualOrientationRepeated, oneof: "field" },
    { no: 35, name: "match_height_from", kind: "message", T: ProfileHeight, oneof: "field" },
    { no: 36, name: "match_height_to", kind: "message", T: ProfileHeight, oneof: "field" },
    { no: 39, name: "match_body_type", kind: "message", T: ProfileBodyTypeRepeated, oneof: "field" },
    { no: 40, name: "match_hair_color", kind: "message", T: ProfileHairColorRepeated, oneof: "field" },
    { no: 41, name: "match_children", kind: "enum", T: proto3.getEnumType(ProfileChildren), oneof: "field" },
    { no: 42, name: "match_drinking", kind: "message", T: ProfileDrinkingRepeated, oneof: "field" },
    { no: 43, name: "match_smoking", kind: "message", T: ProfileSmokingRepeated, oneof: "field" },
    { no: 44, name: "educational_institution", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 45, name: "eye_color", kind: "enum", T: proto3.getEnumType(ProfileEyeColor), oneof: "field" },
    { no: 46, name: "match_eye_color", kind: "message", T: ProfileEyeColorRepeated, oneof: "field" },
    { no: 47, name: "match_sports", kind: "message", T: ProfileSportRepeated, oneof: "field" },
    { no: 48, name: "match_interests", kind: "message", T: ProfileInterestRepeated, oneof: "field" },
    { no: 49, name: "match_education", kind: "message", T: ProfileEducationRepeated, oneof: "field" },
    { no: 50, name: "match_age_from", kind: "scalar", T: 13 /* ScalarType.UINT32 */, oneof: "field" },
    { no: 51, name: "match_age_to", kind: "scalar", T: 13 /* ScalarType.UINT32 */, oneof: "field" },
    { no: 52, name: "match_location", kind: "message", T: ProfileLocation, oneof: "field" },
    { no: 53, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileField {
    return new ProfileField().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileField {
    return new ProfileField().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileField {
    return new ProfileField().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileField | PlainMessage<ProfileField> | undefined, b: ProfileField | PlainMessage<ProfileField> | undefined): boolean {
    return proto3.util.equals(ProfileField, a, b);
  }
}

/**
 * User's match interests wrapper, because of we can't use 'repeated' with 'oneof'.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileInterestRepeated
 */
export class ProfileInterestRepeated extends Message<ProfileInterestRepeated> {
  /**
   * @generated from field: repeated string interests = 1;
   */
  interests: string[] = [];

  constructor(data?: PartialMessage<ProfileInterestRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileInterestRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "interests", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileInterestRepeated {
    return new ProfileInterestRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileInterestRepeated {
    return new ProfileInterestRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileInterestRepeated {
    return new ProfileInterestRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileInterestRepeated | PlainMessage<ProfileInterestRepeated> | undefined, b: ProfileInterestRepeated | PlainMessage<ProfileInterestRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileInterestRepeated, a, b);
  }
}

/**
 * User's match looking reason wrapper, because of we can't use 'repeated' with 'oneof'.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileLookingForRepeated
 */
export class ProfileLookingForRepeated extends Message<ProfileLookingForRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileLookingFor lookings_for = 1;
   */
  lookingsFor: ProfileLookingFor[] = [];

  constructor(data?: PartialMessage<ProfileLookingForRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileLookingForRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lookings_for", kind: "enum", T: proto3.getEnumType(ProfileLookingFor), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileLookingForRepeated {
    return new ProfileLookingForRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileLookingForRepeated {
    return new ProfileLookingForRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileLookingForRepeated {
    return new ProfileLookingForRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileLookingForRepeated | PlainMessage<ProfileLookingForRepeated> | undefined, b: ProfileLookingForRepeated | PlainMessage<ProfileLookingForRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileLookingForRepeated, a, b);
  }
}

/**
 * User's match religion wrapper, because of we can't use 'repeated' with 'oneof'.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileReligionRepeated
 */
export class ProfileReligionRepeated extends Message<ProfileReligionRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileReligion religions = 1;
   */
  religions: ProfileReligion[] = [];

  constructor(data?: PartialMessage<ProfileReligionRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileReligionRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "religions", kind: "enum", T: proto3.getEnumType(ProfileReligion), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileReligionRepeated {
    return new ProfileReligionRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileReligionRepeated {
    return new ProfileReligionRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileReligionRepeated {
    return new ProfileReligionRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileReligionRepeated | PlainMessage<ProfileReligionRepeated> | undefined, b: ProfileReligionRepeated | PlainMessage<ProfileReligionRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileReligionRepeated, a, b);
  }
}

/**
 * User's match marriage wrapper, because of we can't use 'repeated' with 'oneof'.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileMaritalStatusRepeated
 */
export class ProfileMaritalStatusRepeated extends Message<ProfileMaritalStatusRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileMaritalStatus marital_statuses = 1;
   */
  maritalStatuses: ProfileMaritalStatus[] = [];

  constructor(data?: PartialMessage<ProfileMaritalStatusRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileMaritalStatusRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "marital_statuses", kind: "enum", T: proto3.getEnumType(ProfileMaritalStatus), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileMaritalStatusRepeated {
    return new ProfileMaritalStatusRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileMaritalStatusRepeated {
    return new ProfileMaritalStatusRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileMaritalStatusRepeated {
    return new ProfileMaritalStatusRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileMaritalStatusRepeated | PlainMessage<ProfileMaritalStatusRepeated> | undefined, b: ProfileMaritalStatusRepeated | PlainMessage<ProfileMaritalStatusRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileMaritalStatusRepeated, a, b);
  }
}

/**
 * User's match eye color wrapper.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileEthnicityRepeated
 */
export class ProfileEthnicityRepeated extends Message<ProfileEthnicityRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileEthnicity profile_ethnicities = 1;
   */
  profileEthnicities: ProfileEthnicity[] = [];

  constructor(data?: PartialMessage<ProfileEthnicityRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileEthnicityRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_ethnicities", kind: "enum", T: proto3.getEnumType(ProfileEthnicity), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileEthnicityRepeated {
    return new ProfileEthnicityRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileEthnicityRepeated {
    return new ProfileEthnicityRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileEthnicityRepeated {
    return new ProfileEthnicityRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileEthnicityRepeated | PlainMessage<ProfileEthnicityRepeated> | undefined, b: ProfileEthnicityRepeated | PlainMessage<ProfileEthnicityRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileEthnicityRepeated, a, b);
  }
}

/**
 * User's match work wrapper, because of we can't use 'repeated' with 'oneof'.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileSphereOfWorkRepeated
 */
export class ProfileSphereOfWorkRepeated extends Message<ProfileSphereOfWorkRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileSphereOfWork spheres_of_work = 1;
   */
  spheresOfWork: ProfileSphereOfWork[] = [];

  constructor(data?: PartialMessage<ProfileSphereOfWorkRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileSphereOfWorkRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "spheres_of_work", kind: "enum", T: proto3.getEnumType(ProfileSphereOfWork), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileSphereOfWorkRepeated {
    return new ProfileSphereOfWorkRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileSphereOfWorkRepeated {
    return new ProfileSphereOfWorkRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileSphereOfWorkRepeated {
    return new ProfileSphereOfWorkRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileSphereOfWorkRepeated | PlainMessage<ProfileSphereOfWorkRepeated> | undefined, b: ProfileSphereOfWorkRepeated | PlainMessage<ProfileSphereOfWorkRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileSphereOfWorkRepeated, a, b);
  }
}

/**
 * User's match orientation wrapper, because of we can't use 'repeated' with 'oneof'.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileSexualOrientationRepeated
 */
export class ProfileSexualOrientationRepeated extends Message<ProfileSexualOrientationRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileSexualOrientation profile_sexual_orientations = 1;
   */
  profileSexualOrientations: ProfileSexualOrientation[] = [];

  constructor(data?: PartialMessage<ProfileSexualOrientationRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileSexualOrientationRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_sexual_orientations", kind: "enum", T: proto3.getEnumType(ProfileSexualOrientation), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileSexualOrientationRepeated {
    return new ProfileSexualOrientationRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileSexualOrientationRepeated {
    return new ProfileSexualOrientationRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileSexualOrientationRepeated {
    return new ProfileSexualOrientationRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileSexualOrientationRepeated | PlainMessage<ProfileSexualOrientationRepeated> | undefined, b: ProfileSexualOrientationRepeated | PlainMessage<ProfileSexualOrientationRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileSexualOrientationRepeated, a, b);
  }
}

/**
 * User's match body type wrapper, because of we can't use 'repeated' with 'oneof'.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileBodyTypeRepeated
 */
export class ProfileBodyTypeRepeated extends Message<ProfileBodyTypeRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileBodyType profile_body_types = 1;
   */
  profileBodyTypes: ProfileBodyType[] = [];

  constructor(data?: PartialMessage<ProfileBodyTypeRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileBodyTypeRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_body_types", kind: "enum", T: proto3.getEnumType(ProfileBodyType), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileBodyTypeRepeated {
    return new ProfileBodyTypeRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileBodyTypeRepeated {
    return new ProfileBodyTypeRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileBodyTypeRepeated {
    return new ProfileBodyTypeRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileBodyTypeRepeated | PlainMessage<ProfileBodyTypeRepeated> | undefined, b: ProfileBodyTypeRepeated | PlainMessage<ProfileBodyTypeRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileBodyTypeRepeated, a, b);
  }
}

/**
 * User's match hair color wrapper, because of we can't use 'repeated' with 'oneof'.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileHairColorRepeated
 */
export class ProfileHairColorRepeated extends Message<ProfileHairColorRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileHairColor profile_hair_colors = 1;
   */
  profileHairColors: ProfileHairColor[] = [];

  constructor(data?: PartialMessage<ProfileHairColorRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileHairColorRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_hair_colors", kind: "enum", T: proto3.getEnumType(ProfileHairColor), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileHairColorRepeated {
    return new ProfileHairColorRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileHairColorRepeated {
    return new ProfileHairColorRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileHairColorRepeated {
    return new ProfileHairColorRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileHairColorRepeated | PlainMessage<ProfileHairColorRepeated> | undefined, b: ProfileHairColorRepeated | PlainMessage<ProfileHairColorRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileHairColorRepeated, a, b);
  }
}

/**
 * User's match eye color wrapper.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileEyeColorRepeated
 */
export class ProfileEyeColorRepeated extends Message<ProfileEyeColorRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileEyeColor profile_eye_colors = 1;
   */
  profileEyeColors: ProfileEyeColor[] = [];

  constructor(data?: PartialMessage<ProfileEyeColorRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileEyeColorRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_eye_colors", kind: "enum", T: proto3.getEnumType(ProfileEyeColor), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileEyeColorRepeated {
    return new ProfileEyeColorRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileEyeColorRepeated {
    return new ProfileEyeColorRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileEyeColorRepeated {
    return new ProfileEyeColorRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileEyeColorRepeated | PlainMessage<ProfileEyeColorRepeated> | undefined, b: ProfileEyeColorRepeated | PlainMessage<ProfileEyeColorRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileEyeColorRepeated, a, b);
  }
}

/**
 * User's match eye color wrapper.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileDrinkingRepeated
 */
export class ProfileDrinkingRepeated extends Message<ProfileDrinkingRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileDrinking profile_drinkings = 1;
   */
  profileDrinkings: ProfileDrinking[] = [];

  constructor(data?: PartialMessage<ProfileDrinkingRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileDrinkingRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_drinkings", kind: "enum", T: proto3.getEnumType(ProfileDrinking), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileDrinkingRepeated {
    return new ProfileDrinkingRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileDrinkingRepeated {
    return new ProfileDrinkingRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileDrinkingRepeated {
    return new ProfileDrinkingRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileDrinkingRepeated | PlainMessage<ProfileDrinkingRepeated> | undefined, b: ProfileDrinkingRepeated | PlainMessage<ProfileDrinkingRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileDrinkingRepeated, a, b);
  }
}

/**
 * User's match eye color wrapper.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileSmokingRepeated
 */
export class ProfileSmokingRepeated extends Message<ProfileSmokingRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileSmoking profile_smokings = 1;
   */
  profileSmokings: ProfileSmoking[] = [];

  constructor(data?: PartialMessage<ProfileSmokingRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileSmokingRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_smokings", kind: "enum", T: proto3.getEnumType(ProfileSmoking), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileSmokingRepeated {
    return new ProfileSmokingRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileSmokingRepeated {
    return new ProfileSmokingRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileSmokingRepeated {
    return new ProfileSmokingRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileSmokingRepeated | PlainMessage<ProfileSmokingRepeated> | undefined, b: ProfileSmokingRepeated | PlainMessage<ProfileSmokingRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileSmokingRepeated, a, b);
  }
}

/**
 * User's match eye color wrapper.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileSportRepeated
 */
export class ProfileSportRepeated extends Message<ProfileSportRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileSport profile_sports = 1;
   */
  profileSports: ProfileSport[] = [];

  constructor(data?: PartialMessage<ProfileSportRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileSportRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_sports", kind: "enum", T: proto3.getEnumType(ProfileSport), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileSportRepeated {
    return new ProfileSportRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileSportRepeated {
    return new ProfileSportRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileSportRepeated {
    return new ProfileSportRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileSportRepeated | PlainMessage<ProfileSportRepeated> | undefined, b: ProfileSportRepeated | PlainMessage<ProfileSportRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileSportRepeated, a, b);
  }
}

/**
 * User's match education wrapper.
 *
 * @generated from message gdx.gateway.web.profile.v1.ProfileEducationRepeated
 */
export class ProfileEducationRepeated extends Message<ProfileEducationRepeated> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileEducation profile_education = 1;
   */
  profileEducation: ProfileEducation[] = [];

  constructor(data?: PartialMessage<ProfileEducationRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.ProfileEducationRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_education", kind: "enum", T: proto3.getEnumType(ProfileEducation), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileEducationRepeated {
    return new ProfileEducationRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileEducationRepeated {
    return new ProfileEducationRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileEducationRepeated {
    return new ProfileEducationRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileEducationRepeated | PlainMessage<ProfileEducationRepeated> | undefined, b: ProfileEducationRepeated | PlainMessage<ProfileEducationRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileEducationRepeated, a, b);
  }
}

